import { render, staticRenderFns } from "./modifyVersion.vue?vue&type=template&id=1ac24d37&scoped=true&"
import script from "./modifyVersion.vue?vue&type=script&lang=js&"
export * from "./modifyVersion.vue?vue&type=script&lang=js&"
import style0 from "./modifyVersion.vue?vue&type=style&index=0&id=1ac24d37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac24d37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ac24d37')) {
      api.createRecord('1ac24d37', component.options)
    } else {
      api.reload('1ac24d37', component.options)
    }
    module.hot.accept("./modifyVersion.vue?vue&type=template&id=1ac24d37&scoped=true&", function () {
      api.rerender('1ac24d37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerService/components/modifyVersion.vue"
export default component.exports